module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Regálate Perfumes","short_name":"Regálate Perfumes","start_url":"/","background_color":"#123447","theme_color":"#FF800F","display":"minimal-ui","icon":"src/images/icon-regalate.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"04dcb201e3838755e1ccbb600f319dfa"},
    },{
      plugin: require('../node_modules/gatsby-plugin-use-shopping-cart/gatsby-browser.js'),
      options: {"plugins":[],"mode":"payment","cartMode":"client-only","stripePublicKey":"pk_test_ajD1LudGlslHYhZJX2TwtnkK00V4gHqZ7q","currency":"MXN","successUrl":"https://regalateperfumes.netlify.app/success?type=cart","cancelUrl":"https://regalateperfumes.netlify.app/cart","billingAddressCollection":false,"allowedCountries":["MX","US"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
